// This file contains only the QuickSight integration logic
// It assumes the SDK has already been loaded via a script tag in the HTML
// https://unpkg.com/amazon-quicksight-embedding-sdk@2.9.0/dist/quicksight-embedding-js-sdk.min.js

/* global QuickSightEmbedding */

import { flashMessages } from 'core/helpers/flash_messages.js';

export async function initializeQuickSightEmbed(embedUrl) {
  try {
    // Context
    const embeddingContext = await QuickSightEmbedding.createEmbeddingContext();

    // Iframe configurations
    const frameOptions = {
      url: embedUrl,
      container: "#quicksight-embed",
      width: "100%",
      height: "38px" // Initial search bar height
    };

    const contentOptions = {
      panelOptions: {
        panelType: 'SEARCH_BAR',
        focusedHeight: "300px",    // Height when dropdown is open
        expandedHeight: "600px"     // Height when showing answers
      },
      showTopicName: false,
      showPinboard: false,
      allowTopicSelection: false,
      allowFullscreen: true,
      searchPlaceholderText: window.translations.searchPlaceholder
    };

    window.embeddedQnA = await embeddingContext.embedGenerativeQnA(frameOptions, contentOptions);

  } catch (error) {
    flashMessages.setFlash(window.translations.errorMessage, 'danger');
  }
}

window.initializeQuickSightEmbed = initializeQuickSightEmbed;
